const NO_FACILITY_ADDRESS = 'No facility address found.';
const NO_BILLING_ADDRESS = 'No billing address found.';

const generateFormattedAddress = (addressParts, defaultMessage) => {
  if (!addressParts || addressParts.length === 0) {
    return defaultMessage;
  }
  return addressParts.filter(Boolean).join(', ') || defaultMessage;
};

export const getFacilityAddress = (claim) => {
  if (!claim) return NO_FACILITY_ADDRESS;

  const addressParts = [
    claim.facility_addr_1,
    claim.facility_addr_2,
    claim.facility_city,
    claim.facility_state,
    claim.facility_zip
  ];

  return generateFormattedAddress(addressParts, NO_FACILITY_ADDRESS);
};

export const getBillingAddress = (claim) => {
  if (!claim) return NO_BILLING_ADDRESS;

  const addressParts = [
    claim.bill_addr_1,
    claim.bill_addr_2,
    claim.bill_city,
    claim.bill_state,
    claim.bill_zip
  ];

  return generateFormattedAddress(addressParts, NO_BILLING_ADDRESS);
};
